import type { DeleteViewTexts } from "./viewActions/DeleteViewButton";
import type { EditViewTexts } from "./viewActions/EditViewButton";
import type { SetDefaultTitles } from "./viewActions/SetDefaultViewButton";

/** Every word the picker's dialogs use for its list's kind of view. */
export interface SavedViewPickerTexts {
  /** Footer button that opens the save dialog. */
  newLabel: string;
  /** Save dialog title. */
  saveTitle: string;
  /** Placeholder of the empty name field. */
  namePlaceholder: string;
  edit: EditViewTexts;
  delete: DeleteViewTexts;
  setDefault: SetDefaultTitles;
}

/** The temporal grid's words, which the View picker uses. */
export const VIEW_PICKER_TEXTS: SavedViewPickerTexts = {
  newLabel: "New View",
  saveTitle: "Save current view",
  namePlaceholder: "View name",
  edit: {
    title: "Edit view",
    namePlaceholder: "View name",
    refreshLabel: "Replace the saved setup with what's on screen"
  },
  delete: {
    title: "Delete view",
    message: (name) => `Delete "${name}"? The grid keeps whatever it shows now.`
  },
  setDefault: {
    current: "This view opens the page",
    promote: "Open the page with this view"
  }
};
